import HttpService from "../../constant/Api";

const API = "v1/contents";

export const getLocationsService = (
  params = {
    byChildren: true,
    distance: 200,
    lat: 40,
    lng: 60,
    // type: "Station",
  }
) => {
  return HttpService.get(`${API}/locations`, { params });
};
